import React, { useState } from "react";
import "./customSelector.css";
import dropnewicon from "../../../assets/img/dropnewicon.svg";

const SelectorReffered = ({
  label,
  options,
  name,
  value,
  onChange,
  LabelFontSize,
  SelectorFontSize,
  labelColor = "#2C357D80",
  starColor = "red",
  showStar,
  error,
  width,
  borderColor,
  disabled,
  allJobDetailList,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  const labelStyle = {
    fontSize: LabelFontSize,
    color: labelColor,
  };

  const selectStyle = {
    fontSize: SelectorFontSize,
    borderBottom: `1px solid ${borderColor}`,
  };

  return (
    <div className="selector_wrapper" style={{ width: width || "100%" }}>
      <label className="selector_label" style={labelStyle}>
        {label} {showStar && <span style={{ color: starColor }}> *</span>}
      </label>
      <div
        className="custom_selector"
        style={selectStyle}
        onClick={handleToggleDropdown}
      >
        {
  value
    ? options
        ?.flatMap((group) => group.options)
        ?.find((option) => option?.value === value)?.label
    : "Select an option"
}
        <span className={`dropdown_icon ${isOpen ? "open" : ""}`}>
          <img
            src={dropnewicon}
            alt=""
            className={`dropdown_icon ${isOpen ? "open" : ""}`}
          />
        </span>
      </div>

      {isOpen && (
  <div className="custom_dropdown">
    {options?.map((group) => (
      <React.Fragment key={group.category}>
        <div className="section_header">
          {group.category === "referred"
            ? `Referred Candidates (${group.options?.length || 0})`
            : `Other Candidates (${group.options?.length || 0})`}
        </div>
        {group.options?.map((option) => (
          <div
            key={option.value}
            className="custom_option"
            onClick={() => handleOptionClick(option.value)}
          >
            <span>{option.label}</span>
            {option.username && <span>{option.username}</span>}
          </div>
        ))}
        {group.category === "referred" && <div className="divider"></div>}
      </React.Fragment>
    ))}
  </div>
)}

      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default SelectorReffered;
